<div
  class="recently-viewed"
  data-cy="recently-viewed-widget"
  [ngClass]="{ smallScreen: isSmallScreen }"
  (click)="focusWidget(selectedIndex)"
>
  <widget-title
    [sectionButtons]="{ contextMenu: canEdit }"
    [contextMenuOpened]="contextMenuOpened"
    [title]="'Recently Viewed'"
    [movedWidget]="movedWidget"
    (openContextMenu)="openContextMenu($event)"
    (navigate)="navigate()"
  ></widget-title>
  <div class="widget-body">
    <ng-container *ngIf="!isLoading && displayedContext?.items.length > 0; else noResult">
      <search-results-list
        [displayedContext]="displayedContext"
        [items]="displayedContext.items"
        [layoutMode]="layoutMode"
        [isOwner]="false"
        [smallView]="true"
        [maxColumnsInScreen]="true"
        [removeFocus]="true"
        [listView]="{ isEditable: false, isDraggable: false }"
        [listName]="'recently_viewed'"
        [componentFocused]="isFocused"
        [displayBg]="false"
        [resizeChange]="widgetResizeChange$ | async"
        [customScrollHeight]="scrollHeight"
        (mouseover)="keyboardOn = false"
        [defaultResultSections]="{
          showBullets: false,
          showTags: false,
          showSnippet: false,
          showSubtitleInSecondLine: true,
          showAnnotation: false,
          showSubView: false,
          showFavoriteIcon: true,
          showPreviewIcon: false,
          showSummaryIcon: false,
          calcBullets: false,
          showContextMenu: true,
          showFavoriteAction: false
        }"
      ></search-results-list
    ></ng-container>

    <ng-template #noResult>
      <widget-no-result
        *ngIf="!isLoading"
        title="No Recently viewed"
        subtitle="Your Recently viewed resources will show up here"
        [imgModel]="{
          lightUrl: 'widget-recently-empty-light',
          darkUrl: 'widget-recently-empty-dark'
        }"
      >
      </widget-no-result
    ></ng-template>

    <ng-container *ngIf="isLoading">
      <div class="ghost-container" *ngIf="isLoading">
        <result-ghost *ngFor="let i of 8 | fill"></result-ghost>
      </div>
    </ng-container>
  </div>
</div>
